import { put } from '@/httpRequest'

export interface ISessionUpdateLastReadAtRequest {
  last_read_at: number
  session_id: string
  session_type: number
}

export const sessionUpdateLastReadAt = async (
  params: ISessionUpdateLastReadAtRequest
) => {
  const response = await put<null>(`/imApi/session/updateLastReadAt`, params)

  return response
}
